export enum ProductMovementReasonEnum {
    perda = 'perda',
    vencimento = 'vencimento',
    amostra = 'amostra',
    uso_interno = 'uso_interno',
    doacao = 'doacao',
    furto = 'furto',
    devolucao_fornecedor = 'devolucao_fornecedor',
    ajuste_inventario = 'ajuste_inventario',
    outro = 'outro',
}

// lista completa — usada pra resolver o label de qualquer motivo já gravado (ex: reasonLabel() em
// stock-out.svelte/stock-home.svelte), incluindo ajuste_inventario, que não é selecionável manualmente.
export const productMovementReasonOptions = [
    { value: ProductMovementReasonEnum.perda, label: 'Perda/quebra' },
    { value: ProductMovementReasonEnum.vencimento, label: 'Vencido/descartado' },
    { value: ProductMovementReasonEnum.amostra, label: 'Amostra/teste em cliente' },
    { value: ProductMovementReasonEnum.uso_interno, label: 'Uso interno' },
    { value: ProductMovementReasonEnum.doacao, label: 'Doação' },
    { value: ProductMovementReasonEnum.furto, label: 'Furto/extravio' },
    { value: ProductMovementReasonEnum.devolucao_fornecedor, label: 'Devolução ao fornecedor' },
    { value: ProductMovementReasonEnum.ajuste_inventario, label: 'Ajuste de inventário' },
    { value: ProductMovementReasonEnum.outro, label: 'Outro' },
]

// opções pro select do formulário manual de saída — ajuste_inventario é marcado só pela ferramenta
// "Ajuste" (stock-adjust-form.svelte), nunca escolhido manualmente aqui.
export const manualProductMovementReasonOptions = productMovementReasonOptions.filter(
    (el) => el.value !== ProductMovementReasonEnum.ajuste_inventario,
)
